var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import getTranslation from '../../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { Inline, Inset, Stack } from 'syf-component-library/ui/spacing';
import { getPromoCenterAnalyticsProps } from '../../../const/analytics/promo-center';
import getAccordionIcon from '../../../helpers/getAccordionIcon';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
import { StyledHeader, StyledTermsAccordion, StyledTermsList } from './subcomponents';
var TermDetailsAccordion = function (_a) {
    var header = _a.header, installmentPercentage = _a.installmentPercentage, _b = _a.isCollapsed, isCollapsed = _b === void 0 ? false : _b;
    var t = getTranslation().t;
    var _c = useState(!isCollapsed), expanded = _c[0], setExpanded = _c[1];
    var isMobile = useDeviceWidth();
    var termsArray = [
        t('selectPay.termDetailsBullet1Text'),
        t('selectPay.termDetailsBullet2Text', {
            percentageValue: installmentPercentage
        }),
        t('selectPay.termDetailsBullet3Text'),
        t('selectPay.termDetailsBullet4Text'),
        t('selectPay.termDetailsBullet5Text')
    ];
    return (_jsx(Inset, { bottom: isMobile ? 'base' : 'large', top: isMobile ? 'base' : undefined, children: _jsx(StyledTermsAccordion, __assign({}, getPromoCenterAnalyticsProps(expanded).accordion, { id: "term-details", expanded: expanded, transitionDuration: 0, headerClickCallBack: function () { return setExpanded(function (prev) { return !prev; }); }, className: "ensightencustomevent", header: _jsxs(StyledHeader, { as: "header", alignItems: "center", children: [_jsx(StyledText, { weight: "bold", lineHeight: 1.5, children: header }), _jsx(Inline, { size: "medium" }), _jsx(FontAwesomeIcon, { icon: getAccordionIcon(expanded), size: "1x", color: colors.cyanBlue })] }), body: _jsx(RenderIf, { condition: expanded, children: _jsxs("section", { children: [_jsx(StyledText, { lineHeight: 1.67, whiteSpace: "pre-line", size: "small", weight: "bold", children: t('selectPay.promotionalTermDetailsSubheading') }), _jsx(StyledTermsList, { children: termsArray.map(function (text) { return (_jsxs("li", { children: [_jsx(Stack, { size: "medium" }), _jsx(StyledText, { as: "span", whiteSpace: "pre-line", size: "small", lineHeight: 1.67, children: text })] }, text)); }) })] }) }) })) }));
};
export default TermDetailsAccordion;
//# sourceMappingURL=index.js.map